// The client half of the compliance event vocabulary. Its sibling is
// apps/api/src/api/component/compliance/analytics/compliance_analytics.constants.ts,
// which owns Intake Submitted. No event name appears in both: a name emitted from
// both sides would double its own count with nothing on the payload to separate them.

export const COMPLIANCE_EVENTS = {
  ViewedIntakePage: 'Intake Page Viewed',
  StartedIntake: 'Intake Started',
  AnsweredIntakeQuestion: 'Intake Question Answered',
  CompletedIntakeSection: 'Intake Section Completed',
  BlockedOnIncompleteSection: 'Intake Section Blocked',
  FailedIntakeSubmit: 'Intake Submit Failed',
  ViewedReportPage: 'Compliance Report Viewed',
  RenderedReport: 'Compliance Report Rendered',
  ExpandedReportObligation: 'Compliance Report Obligation Expanded',
  JumpedToReportStatus: 'Compliance Report Status Jumped',
  ClickedReportCta: 'Compliance Report CTA Clicked',
  OpenedReportPrintDialog: 'Compliance Report Print Dialog Opened',
  ViewedPlansPage: 'Compliance Plans Viewed',
  SelectedPlan: 'Compliance Plan Selected',
} as const

export type ComplianceEventName =
  (typeof COMPLIANCE_EVENTS)[keyof typeof COMPLIANCE_EVENTS]

/**
 * Where the surface was rendered. Intake and the report are slated for reuse
 * inside the app for entitled customers, so every event carries this and no
 * event name mentions the funnel.
 */
export const ANALYTICS_SURFACES = {
  SignupFunnel: 'signup_funnel',
  InApp: 'in_app',
} as const

export type AnalyticsSurface =
  (typeof ANALYTICS_SURFACES)[keyof typeof ANALYTICS_SURFACES]

export const REPORT_CTAS = { Consult: 'consult', Plans: 'plans' } as const
export type ReportCta = (typeof REPORT_CTAS)[keyof typeof REPORT_CTAS]

/**
 * The only question keys whose answer value rides along on
 * `Intake Question Answered`. Every other question sends its key alone.
 *
 * Membership is not a judgment call: a key belongs here only if the API's
 * `crm_sync.service.ts` payload already sends it to HubSpot, so this adds no
 * new destination for an answer. Check a candidate against that payload before
 * adding it.
 */
export const VALUE_SAFE_QUESTION_KEYS: ReadonlySet<string> = new Set([
  'tax_treatment',
  'practice_size',
  'has_multiple_owners',
  'expected_income_band',
  'client_status',
])
